/*
 * Copyright Evollis 2022
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import InformationButton from "../../../components/molecules/InformationButton"
import { getCountryFromLanguage } from "../../../core/service/BusinessLogicService"
import { loc } from "../../../core/utils"
import Date from "../../../form/Date"
import NumberFieldPhone from "../../../form/NumberFieldPhone"
import RadiosField from "../../../form/RadiosField"
import TextField from "../../../form/TextField"
import { getCivilStatuses } from "../service/ClientPageServices"
import Bloc from "./Bloc"
import React from "react"
import { Col, Row } from "react-bootstrap"

export default function SignatoryBloc(props) {
  const { tunnelData, values, children, name, index, blocFields, completedFields } = props
  const { clientPageConfiguration, data } = tunnelData
  const { signatory } = clientPageConfiguration

  return (
    <Bloc
      hide={!signatory}
      name={"Signatory"}
      data={index + 1}
      completedFields={completedFields}
      totalFieldsNumber={blocFields.length}
    >
      <div className="hard-shadow-white-block">
        <Row>
          <Col lg={12}>
            <div className="title-signatory">
              <RadiosField
                name={`${name}.title`}
                checked={`${values?.signatories?.[index]?.title}`}
                items={getCivilStatuses(tunnelData)}
                label={loc`Title`}
                disabled={false}
              >
                <InformationButton placement="right" overlayText={loc("Signatory tooltip")} />
              </RadiosField>
            </div>
          </Col>
          <Col lg={12}>
            <TextField name={`${name}.name`} label={loc`Signatory name`} disabled={false} />
          </Col>
          <Col lg={12}>
            <TextField name={`${name}.firstName`} label={loc`Signatory first name`} disabled={false} />
          </Col>
          <Col>
            <Date
              hidden={false}
              name={`${name}.signatoryBirthdate`}
              label={loc`Signatory birthdate`}
              trimOnBlur={true}
              format={"DD/MM/YYYY"}
            />
          </Col>
          <Col lg={12}>
            <TextField
              name={`${name}.email`}
              label={loc`Signatory email`}
              disabled={false}
              formGroupProps={{ style: { flex: 1 } }}
            >
              <InformationButton overlayText={loc("Signatory email info")} />
            </TextField>
          </Col>
          <Col lg={12}>
            <NumberFieldPhone
              countryCode={getCountryFromLanguage(data?.order?.orderLanguageTag)}
              hidden={!signatory?.includes("phoneNumber")}
              name={`${name}.phoneNumber`}
              label={loc`Signatory mobile phone`}
              placeholder={"+33"}
              formGroupProps={{ style: { flex: 1 } }}
            >
              <InformationButton overlayText={loc("Signatory mobile phone infos")} />
            </NumberFieldPhone>
          </Col>
        </Row>
        {children}
      </div>
    </Bloc>
  )
}
